import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  DestroyRef,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ToastAlertService } from '@core/services';
import { WorkPlaceGroupModalComponent } from '../../../components/modals/groups/work-place-group-modal/work-place-group-modal.component';
import { WorkPlaceGroup } from '../../../models/work-place-group.model';
import {
  BusinessService,
  ConfigService,
  UserService,
  WorkplaceGroupService,
} from '../../../services';
import { ModalAlertComponent } from '@shared/components';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Cookies } from 'typescript-cookie';

@Component({
  templateUrl: './work-place-group-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    ToolbarComponent,
    SearchFieldComponent,
    ButtonComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
})
export class WorkPlaceGroupPageComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  private dialog = inject(MatDialog);
  private workPlaceService = inject(WorkplaceGroupService);
  private alertService = inject(ToastAlertService);
  private destroyRef = inject(DestroyRef);

  public icon = 'add';
  dataSource: MatTableDataSource<WorkPlaceGroup>;
  fielInput!: string;
  displayedColumns: string[] = ['name', 'description', 'options'];
  //DATA
  private businessId: number | null | undefined;
  public selectedBussines = -1;
  public bussines: any[] = [];
  public isSysAdmin = inject(ConfigService).isSysAdmin;
  private userService = inject(UserService);
  private businessService = inject(BusinessService);

  constructor() {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.loadworkers();
  }
  loadworkers() {
    const business = Cookies.get('bussinesId');
    if (business != null) {
      this.businessId = parseInt(business.toString());
      this.selectedBussines = this.businessId;
    } else {
      if (this.selectedBussines === -1) {
        this.businessId = null;
      }
    }

    this.getBusiness();
    this.chargueData();
  }
  private getBusiness() {
    this.businessService
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            this.bussines = request.reply;
            console.log(request.reply);
          }
        },
      });
  }

  ValidBusiness_id(): boolean {
    return this.businessId === null;
  }

  modalAction(action?: WorkPlaceGroup) {
    if (this.selectedBussines === -1) {
      this.alertService.error('Por favor selecciona una empresa.');
    } else {
      let width: string;
      if (window.innerWidth <= 768) {
        width = '90%';
      } else {
        width = '50%';
      }

      const dialogActionDetail = this.dialog.open(
        WorkPlaceGroupModalComponent,
        {
          width: width,
          data: {
            action: action,
            businessId: this.selectedBussines,
          },
          disableClose: true,
        }
      );
      dialogActionDetail
        .beforeClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(result => {
          if (result) {
            this.loadworkers();
          }
        });
    }
  }

  modalDelete(action: WorkPlaceGroup) {
    const dialogDelete = this.dialog.open(ModalAlertComponent, {
      data: action?.name,
      disableClose: true,
    });
    dialogDelete
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: boolean) => {
        if (!result) return;

        // console.log(action.workplaceid)
        this.workPlaceService
          .deleteWorkplace(action.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: resp => {
              if (resp.code === 10000) {
                this.alertService.sucess(
                  'Grupos de puestos de trabajo eliminado'
                );
                this.loadworkers();
              } else {
                this.alertService.error(resp.detail);
              }
            },
            error: error => {
              this.alertService.error(`Error: ${error}`);
            },
          });
      });
  }

  chargueData() {
    this.workPlaceService
      .getWorkplaces(this.selectedBussines)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.dataSource = new MatTableDataSource(resp.reply);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          }
        },
      });
  }
}
